import { Dispatch, SetStateAction } from "react";
import {
  ModelBundleSortFieldEnum,
  SortOrderEnum,
} from "../../../generated/graphql";
import { MainTableHeaderTitle } from "../../shared/Style/Style";
import { BundlesTableHeader as TableHeader } from "../styles";
import { ContentTypeFilter } from "./filters/ContentTypeFilter";
import { TagsFilter } from "./filters/TagsFilter";
import { StatusFilter } from "./filters/StatusFilter";
import { TableSortLabel } from "@material-ui/core";
import { Filters } from "../BundlesStorage";

interface BundlesTableHeaderProps {
  sortField: ModelBundleSortFieldEnum;
  sortOrder: SortOrderEnum;
  filters: Filters;
  setSortField: Dispatch<SetStateAction<ModelBundleSortFieldEnum>>;
  setSortOrder: Dispatch<SetStateAction<SortOrderEnum>>;
  setFilters: Dispatch<SetStateAction<Filters>>;
  setPage: Dispatch<SetStateAction<number>>;
}

const bundlesTableHeader: {
  label: string;
  field?: ModelBundleSortFieldEnum;
  hasFilter?: boolean;
}[] = [
  { label: "Назва моделі", field: ModelBundleSortFieldEnum.Name },
  { label: "Номер", field: ModelBundleSortFieldEnum.Number },
  { label: "Тип контенту", hasFilter: true },
  { label: "Внутрішні теги", hasFilter: true },
  { label: "Статус", hasFilter: true },
  { label: "Дата створення", field: ModelBundleSortFieldEnum.CreatedDate },
];

export const BundlesTableHeader = ({
  sortField,
  sortOrder,
  filters,
  setSortField,
  setSortOrder,
  setFilters,
  setPage,
}: BundlesTableHeaderProps) => {
  const handleSort = (field: ModelBundleSortFieldEnum) => {
    setPage(0);
    if (sortField === field) {
      setSortOrder((prev) =>
        prev === SortOrderEnum.Asc ? SortOrderEnum.Desc : SortOrderEnum.Asc,
      );
    } else {
      setSortField(field);
      setSortOrder(SortOrderEnum.Asc);
    }
  };

  return (
    <TableHeader>
      {bundlesTableHeader.map(({ label, field, hasFilter }) => (
        <MainTableHeaderTitle
          key={label}
          onClick={() => field && handleSort(field)}
          style={{
            cursor: "pointer",
            whiteSpace: "nowrap",
            marginRight: "0px",
            width: "100%",
          }}
        >
          {field && (
            <span>
              {label}
              <TableSortLabel
                key={sortField}
                active={sortField === field}
                direction={
                  sortField === field && sortOrder === SortOrderEnum.Desc
                    ? "desc"
                    : "asc"
                }
                hideSortIcon={false}
                style={{
                  cursor: "pointer",
                }}
              />
            </span>
          )}
          {hasFilter && label === "Тип контенту" && (
            <ContentTypeFilter
              label={label}
              selectedValues={filters.contentTypes}
              onChange={(values) => {
                setFilters((prev) => ({ ...prev, contentTypes: values }));
                setPage(0);
              }}
            />
          )}
          {hasFilter && label === "Внутрішні теги" && (
            <TagsFilter
              label={label}
              selectedValues={filters.tagIds}
              onChange={(values) => {
                setFilters((prev) => ({ ...prev, tagIds: values }));
                setPage(0);
              }}
            />
          )}
          {hasFilter && label === "Статус" && (
            <StatusFilter
              label={label}
              selectedValue={filters.isDraft}
              onChange={(value) => {
                setFilters((prev) => ({ ...prev, isDraft: value }));
                setPage(0);
              }}
            />
          )}
        </MainTableHeaderTitle>
      ))}
    </TableHeader>
  );
};
